import { general } from './general';
import { datecontrol } from './datecontrol';
import { textarea } from './textarea';
import { radio } from './radio';
import { checkbox } from './checkbox';
import { country } from './country';
import { number } from './number';
import { branch } from './branch';

export const benefit = (data = {}) => {
  const processData = (data === null) ? {} : data;
  return general('benefit', {
    Began: datecontrol(processData.Began),
    End: datecontrol(processData.End),
    Frequency: radio(processData.Frequency),
    // Required for first "Other" explanation
    OtherFrequencyTypeExplanation: textarea(processData.OtherFrequencyTypeExplanation),
    // Required for the nested "Other" explanation within the parent "Other"
    OtherFrequency: textarea(processData.OtherFrequency),
    Received: datecontrol(processData.Received),
    Country: country(processData.Country),
    Value: number(processData.Value),
    ValueEstimated: checkbox(processData.ValueEstimated),
    Reason: textarea(processData.Reason),
    Obligated: branch(processData.Obligated),
    ObligatedExplanation: textarea(processData.ObligatedExplanation),
  });
};
